<template>
    <div class="app-container">

        <el-tabs v-model="curAdPlatId" @tab-click="handleTabClick">
            <el-tab-pane :key="item.value" v-for="(item,index) in tabList" :label="item.label" :name="item.value"></el-tab-pane>
        </el-tabs>

        <el-tabs v-model="titleTab" @tab-click="handleTitleTabClick">
            <el-tab-pane label="标题" name="title"></el-tab-pane>
            <el-tab-pane label="标题包" name="titlePackage"></el-tab-pane>
        </el-tabs>

        <Title v-if="'title'==titleTab" :cur-ad-plat-id="curAdPlatId"></Title>

        <TitlePackage v-if="'titlePackage'==titleTab" :cur-ad-plat-id="curAdPlatId"></TitlePackage>

    </div>
</template>

<script>
import Vue from 'vue';
import {Table, TableColumn, FormItem, Input, Button, Dialog, Loading, Form, MessageBox, Notification, Tabs, TabPane} from 'element-ui';
import Pagination from '@/components/Pagination/index.vue'
import TitlePage from './title.vue'
import TitlePackagePage from './titlePackage.vue'
import {ToolAdPlatMap} from '../../../../utils/map'
import Title from "./title";
import TitlePackage from "./titlePackage";

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Button)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Loading)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification


export default {
    components: {TitlePackage, Title, Pagination},
    data() {
        return {
            curAdPlatId: '400',
            tabList: ToolAdPlatMap,
            titleTab: 'title',
        }
    },
    created() {

    },
    methods: {
        handleTabClick(tab, event) {
            // 切换tab 重新请求列表
            this.titleTab = 'title';
            console.log(this.curAdPlatId);
        },
        handleTitleTabClick(tab, event) {
            // 切换tab 重新请求列表
        },
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/tool/title/index.vue